import { SAFEA_V3_ENABLED, SAFEA_VERSION, SAFEA_VERSIONS } from '~/constants/_core/safea-v3';

export const state = () => ({
  hostname : null,
  isSSR    : false,
  isReady  : false
});

export const mutations = {
  SET_HOSTNAME(state, serverHost) {
    if (process.env.NODE_ENV === 'development' || process.env.FORCE_DEV_ENV) {
      state.hostname = process.env.DEV_APPLICATION_HOST;
    } else {
      if (process.server) {
        state.hostname = serverHost;
      } else {
        state.hostname = location.host;
      }
    }
  },
  SET_IS_SSR(state, isSSR) {
    state.isSSR = isSSR;
  },
  SET_IS_READY(state, isReady) {
    state.isReady = isReady;
  }
};

export const actions = {
  async nuxtServerInit({ dispatch }, { req }) {
    await dispatch('init', req.headers.host);
  },

  async init({ dispatch, commit, state }, serverHost) {
    if (state.isReady) {
      return;
    }

    commit('SET_HOSTNAME', serverHost);

    if (process.server) {
      commit('SET_IS_SSR', true);
    }

    let tokenId;
    if (process.client) {
      const searchParams = new URLSearchParams(window.location.search);
      tokenId = searchParams.get('tokenId');
    } else {
      tokenId = this.$router.currentRoute.query.tokenId;
    }

    if (tokenId) {
      await dispatch('handleTokenId', tokenId);
      localStorage.setItem('isSSOAccess', true);
    }

    if (SAFEA_V3_ENABLED) {
      await dispatch('_core/application/init');
    } else {
      await dispatch('_core/tenant/init');
      await dispatch('_core/auth/init');
    }


    commit('SET_IS_READY', true);
  },

  async handleTokenId({ store }, tokenId) {
    if (SAFEA_VERSION === SAFEA_VERSIONS.V3) {
      console.warn('[Cockpit] Received a tokenId in the URL, but it is not supported in v3. Ignoring it.');
      return;
    }

    // The happy v2 flow
    if (SAFEA_VERSION === SAFEA_VERSIONS.V2) {
      this.$token.set(tokenId);
    }
  }
};
